import {
	dillardsModal
} from './_dillardsModal';
import {
	preventDoubleClick
} from '../global/_doubleClick'; 

const useAnywayModalFromModal = (response, returnHTML) => {
    var address = response.JSON;
    var {address1, address2, city, state, zip} = address;
    let html = `<div id="confirm-address">
                    <p><strong>We were unable to verify the entered address.</strong></p>
                    <div class="address">${address1}${address2 != '' ? ' ' + address2 + ',' : ','} ${city}, ${state} ${zip}</div>
                    <br>
                    <div class="modal-footer">
                        <button data-twist="use-address-button" type="button" class="btn btn-primary prevent-double-click-hack-for-ibm-cookie-problem" onclick="$('.avForm').submit();">Use This Address Anyway</button>
                		<button type="button" class="btn btn-secondary" data-dismiss="modal" onclick="$('.clickSubmit.oneClickOnly').html('Submit');$('.clickSubmit.oneClickOnly').removeClass('disabled');$('.clickSubmit.oneClickOnly').css('opacity','1');">Edit Address</button>        
                    </div>
                </div>`
    dillardsModal.triggerModal(returnHTML(html), 'ATTENTION', 'modal-address-verification');
};

const useAnywayModal = function(response ,returnHTML) {
    var address = response.JSON;
    var {address1, address2, city, state, zip} = address;
    let html = `<div id="confirm-address">
                    <p><strong>We were unable to verify the entered address.</strong></p>
                    <div class="address">${address1}${address2 != '' ? ' ' + address2 + ',' : ','} ${city}, ${state} ${zip}</div>
                    <br>
                    <div class="modal-footer">
                        <button data-twist="use-address-button" type="button" class="btn btn-primary prevent-double-click-hack-for-ibm-cookie-problem" onclick="$('.avForm').submit();">Use This Address Anyway</button>
                        <button data-twist="edit-address-button" type="button" class="btn btn-secondary" data-toggle="modal" data-target=".modal-address-verification" onclick="$('.clickSubmit.oneClickOnly').html('Submit');$('.clickSubmit.oneClickOnly').removeClass('disabled');$('.clickSubmit.oneClickOnly').css('opacity','1');">Edit Address</button>
                    </div>
                </div>`
    dillardsModal.triggerModal(returnHTML(html), 'ATTENTION', 'modal-address-verification');
};

export{
	useAnywayModalFromModal,
	useAnywayModal
}
